/**
 * @license ngGridPanel
 * (c) 2014 Hacklone https://github.com/Hacklone
 * License: MIT
 */
angular.module('ngGridPanel', ['ngAnimate'])
    .directive('gridPanel', ['$animate', '$compile', '$window', '$document', '$timeout', '$state',
      function($animate, $compile, $window, $document, $timeout, $state) {
        return {
            restrict: 'AE',
            scope: {
                onPanelOpened: '&',
                onPanelClosed: '&'
            },
            compile: function(tElement, tAttr) {
                var windowElement = angular.element($window);
                var htmlAndBodyElement = angular.element($document).find('html, body');

                var gridItemTemplate = getGridItemTemplate();
                var gridPanelTemplate = getGridPanelTemplate();

                if (!tAttr.repeat) {
                    throw new Error('repeat attribute must be set');
                }

                var matchArray = tAttr.repeat.match(/\s?(.*)\sin\s(.*)\s?/);
                if (!matchArray || matchArray.length < 3) {
                    throw new Error('repeat attribute must be set like repeat="item in items"');
                }

                var iterationVariableName = matchArray[1];
                var collectionName = matchArray[2];

                var panel;
                var panelOpenedAfter;
                var panelScope;

                return {
                    pre: function($scope, $element) {
                        _init();

                        function _init() {
                            $scope.$parent.$watchCollection(collectionName, _onItemsChanged);
                        }

                        function _onItemsChanged(items) {
                            //todo: remove only items that need to be removed
                            $element.empty();

                            //console.log('item', items);

                            if (!angular.isUndefined(items)) {

                                for (var i = 0, len = items.length; i < len; i++) {
                                    var itemScope = $scope.$new();
                                    var item = items[i];

                                    itemScope[iterationVariableName] = item;

                                    var itemElement = gridItemTemplate.clone();

                                    itemElement.addClass('grid-panel-item-' + i).on('click', function(i, item) {
                                        return function(e) {
                                            // if (e.target == ".btn.btn-success.btn-sm.n-a-btn" || e.target.localName == "button" || e.target.className == "icon-heart"
                                            //      || e.target.className == "btn btn-success btn-sm n-a-btn voted" || e.target.className === "btn btn-success voted")
                                            //     return;
                                            if (angular.element(e.target).hasClass('toggle-detail-button')) {
                                                _onGridItemClick(i, item); // Llama a la función solo si se hace clic en el botón
                                            }
                                        };
                                    }(i, item));

                                    $animate.enter(itemElement, $element);

                                    $compile(itemElement)(itemScope);
                                }
                            }
                        }

                        function _onGridItemClick(index, item) {


                            var gridItem = $element.find('.grid-panel-item-' + index);

                            //Clase al producto excepto en version mobile
                            if (angular.element($window).width() > 768) {
                                gridItem.find('.single-product').addClass('active');
                                var els = angular.element('.single-product');
                                angular.forEach(els, function(el) {
                                    if (el.getAttribute("id") !== item.slug) {
                                        angular.element(el).removeClass("active");
                                    }
                                })
                            }

                            var lastGridItem = getLastGridItem(gridItem);
                            var lastGridItemClass = lastGridItem.attr('class');

                            if (panel && panelOpenedAfter === lastGridItemClass) {

                                let isAnyPanelOpened = angular.element(document).find("grid-panel-content").length > 0;

                                isAnyPanelOpened ? updatePanel() : addPanel()

                            } else {
                                addPanel();
                            }

                            //updateTriangle();

                            // Desplieque del producto con toggel, en progreso
                            /*$('.single-product').on('click', function() {
                                $('.gridPanelNoContent').toggleClass('activeHeight');
                            });*/

                            if (angular.element($window).width() > 768)
                                scrollToPanel();

                            function getLastGridItem(gridItem) {
                                var current = gridItem;
                                var next = gridItem.next();

                                while (next.length && current.offset().top === next.offset().top) {
                                    current = next;

                                    next = current.next();
                                }

                                return current;
                            }

                            function addPanel() {
                                panelOpenedAfter = lastGridItemClass;

                                var isNewPanel = !!panel;

                                closePanel();

                                panelScope = $scope.$new();
                                panelScope[iterationVariableName] = item;

                                panel = gridPanelTemplate.clone();

                                panel.find('.close-x').on('click', function(item) {
                                    return function() {
                                        closePanel();

                                        $scope.onPanelClosed({
                                            item: item
                                        });
                                    };
                                }(item));

                                $animate.enter(panel, null, lastGridItem);

                                $compile(panel)(panelScope);
                                panelScope.$digest();

                                if (isNewPanel) {
                                    $scope.onPanelOpened({
                                        item: item
                                    });
                                }
                            }

                            function updatePanel() {
                                panelScope[iterationVariableName] = item;
                                panelScope.$digest();
                            }

                            function closePanel(event) {
                                // Pendiente cerrar con toogleclass

                                if (panel) {
                                    $animate.leave(panel);
                                    panel = undefined;
                                }

                                if (panelScope) {
                                    panelScope.$destroy();
                                    panelScope = undefined;
                                }

                                event = event || window.event;


                                //Asegura eliminacion de la clase activa de todos los productos excepto en mobile que no hay
                                if (!angular.isUndefined(event) && event.target.className === 'close-x') {
                                    if (angular.element($window).width() > 768) {
                                        angular.forEach(els, function(el) {
                                            angular.element(el).removeClass("active");
                                        })
                                    }
                                }

                                $scope.$digest();


                               // Al cerrar la ficha del producto debemos salir del estado main.vote.category.product

                               let isAnyPanelOpened = angular.element(document).find("grid-panel-content").length > 0;
                               if (isAnyPanelOpened) {
                                    $state.go('main.vote.category', { slugCategory: $scope.$parent.$parent.selectedCategory.slug }, {
                                        location: true,
                                        notify: false
                                    });
                                }
                            }

                            function scrollToPanel() {
                                if (!panel) {
                                    return;
                                }

                                //Scroll a la ficha del producto excepto en movil
                                //if (angular.element($window).width() > 768) {

                                $timeout(scrollAnimate, 250);

                                function scrollAnimate() {
                                    htmlAndBodyElement.animate({
                                        scrollTop: gridItem.offset().top
                                    }, 500);
                                }
                                //}
                            }

                            /*function updateTriangle() {
                                if(!panel) {
                                    return;
                                }

                                panel.find('.triangle').css({
                                    left: gridItem.position().left + (gridItem.width() / 2)
                                });
                            }*/
                        }
                    }
                };

                function getGridItemTemplate() {
                    var gridItemTemplate = tElement.find('grid-panel-item, .grid-panel-item').clone();
                    if (!gridItemTemplate.length) {
                        throw new Error('grid-panel-item template must be set');
                    }

                    return gridItemTemplate;
                }

                function getGridPanelTemplate() {
                    var gridPanelTemplate = tElement.find('grid-panel-content, .grid-panel-content').clone();
                    if (!gridPanelTemplate.length) {
                        throw new Error('grid-panel-content template must be set');
                    }

                    gridPanelTemplate
                        .prepend(angular.element('<div class="box-close-x"> <div class="close-x">'))
                        /*.prepend(angular.element('<div class="triangle">'));*/

                    return gridPanelTemplate;
                }
            }
        };
    }]);
